import { styled } from '@mui/material/styles';

export const SelectRoot = styled('div', {
  name: 'Select',
  slot: 'Root',
})({
  position: 'relative',
});
